import { privateAxios } from "../../../config/apiConfig";
import {
  CREATE_SIZE_FAILURE,
  CREATE_SIZE_REQUEST,
  GET_ALL_SIZE_SUCCESS,
  GET_ALL_SIZE_REQUEST,
  GET_ALL_SIZE_FAILURE,
  DELETE_SIZE_REQUEST,
  DELETE_SIZE_FAILURE,
  UPDATE_SIZE_REQUEST,
  UPDATE_SIZE_FAILURE,
  DELETE_SIZE_SUCCESS,
} from "./ActionType";
import { toast } from "react-toastify";

export const getAllSize = () => async (dispatch) => {
  dispatch({ type: GET_ALL_SIZE_REQUEST });
  try {
    const { data } = await privateAxios.get(`admin/sizes`);
    dispatch({ type: GET_ALL_SIZE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_SIZE_FAILURE, payload: error.message });
  }
};

export const createSize = (sizeData) => async (dispatch) => {
  dispatch({ type: CREATE_SIZE_REQUEST });
  try {
    const { data } = await privateAxios.post(`admin/size`, sizeData);
    if (data.status === "SUCCESS") {
      dispatch(getAllSize());
      toast.success(data.response);
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: CREATE_SIZE_FAILURE, payload: error.message });
  }
};

export const updateSize = (sizeId, sizeData) => async (dispatch) => {
  dispatch({ type: UPDATE_SIZE_REQUEST });
  try {
    const { data } = await privateAxios.put(
      `admin/size/${sizeId}`,
      sizeData
    );
    if (data.status === "SUCCESS") {
      dispatch(getAllSize());
      toast.success("Size Updated Successfully");
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: UPDATE_SIZE_FAILURE, payload: error.message });
  }
};

export const deleteSize = (sizeId) => async (dispatch) => {
  dispatch({ type: DELETE_SIZE_REQUEST });
  try {
    const { data } = await privateAxios.delete(`admin/size/${sizeId}`);
    if (data.status === "SUCCESS") {
      dispatch({ type: DELETE_SIZE_SUCCESS, payload: sizeId })
      dispatch(getAllSize());
      toast.success(data.response);
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: DELETE_SIZE_FAILURE, payload: error.message });
  }
};
